
const EmojiReg = /(emoji:\d+)/

export function convertRichComment(comment) {
  var richComment = { id: comment.id, userName: comment.username, level: comment.level || 0,avatar:comment.avatar, category: 'comment', createDate: comment.createDate, segments: [] }
  var segments = comment.content.split(EmojiReg)

  segments.forEach(s => {
    var segment
    if (EmojiReg.test(s)) {
      s = s.replace(/(emoji:)(\d+)/, '$2')
      segment = { type: 'img', content: s }
      richComment.segments.push(segment)
    } else {
      segment = { type: 'text', content: s }
      richComment.segments.push(segment)
    }
  })
  return richComment
}

export function convertRichBarrage(brrage) {
  var segments = []
  var arr = brrage.split(EmojiReg)

  arr.forEach(s => {
    var segment
    if (EmojiReg.test(s)) {
      s = s.replace(/(emoji:)(\d+)/, '$2')
      segment = { type: 'img', content: s }
      segments.push(segment)
    } else {
      segment = { type: 'text', content: s }
      segments.push(segment)
    }
  })
  return segments
}

